var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.filteredUsers,"loading":_vm.loading,"disabled":_vm.disabled,"value":_vm.wrappedValue,"hide-details":"","dense":""},on:{"input":_vm.onInput},scopedSlots:_vm._u([{key:"append-outer",fn:function(){return [_vm._t("append-outer")]},proxy:true},{key:"selection",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"ma-1"},[_c('UserBadge',{attrs:{"uid":item}})],1)]}},{key:"item",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
var item = ref.item;
return [_c('v-list-item',_vm._g(_vm._b({},'v-list-item',attrs,false),on),[_c('div',{staticClass:"ma-1"},[_c('UserBadge',{attrs:{"uid":item}})],1)])]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }